import { render, staticRenderFns } from "./BranchNetsisInfo.vue?vue&type=template&id=d35aa8e6&"
import script from "./BranchNetsisInfo.vue?vue&type=script&lang=js&"
export * from "./BranchNetsisInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports